import { Field, FieldArray, Form, Formik } from 'formik';
import { useEffect, useState } from 'react';
import Modal from '../../SharedComponents/Modal';
import PlusCircle from '../../SharedComponents/Svg/PlusCircle';
import React from 'react';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import Loading from '../../SharedComponents/Loading';
import * as yup from 'yup';
import { addBranch, getLanguages } from './ApiSettings';
import Notification from '../../SharedComponents/Notification';
import { useTranslation } from 'react-i18next';
import LanguageList from '../../SharedComponents/LanguageList';

export default function AddBranch(props) {
  const queryClient = useQueryClient();
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const { id } = props.id ? props : 1;
  const { typeId, activeMenu, orderNum } = props;
  // Mutate Data to Create New Page
  const addBranchMutation = useMutation(addBranch, {
    onSuccess: async (data) => {
      if (data.isDone) {
        queryClient.invalidateQueries(['settings']);

        setIsOpen(false);
      }
    },
  });
  return (
    <>
      {addBranchMutation.isSuccess && <Notification message={t('Branch Added')} />}
      <button
        type="button"
        onClick={() => setIsOpen(!isOpen)}
        className={`bg-lightgreen ${
          t.language === 'en' ? '' : 'space-x-reverse'
        } space-x-1 text-sm font-bold text-white flex items-center hover:bg-lightgreenhover shadow  px-4 py-2 rounded transition duration-300 ease-in-out`}
      >
        <PlusCircle className="w-5 h-5" /> <span>{t('Add New Branch')}</span>
      </button>

      {isOpen && (
        <ModalContainer
          id={id}
          typeId={typeId}
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          activeMenu={activeMenu}
          orderNum={orderNum}
          addBranchMutation={addBranchMutation}
        />
      )}
    </>
  );
}

const ModalContainer = (props) => {
  const { isOpen, setIsOpen, id, typeId, activeMenu, orderNum, addBranchMutation } = props;
  const [languageId, setLanguageId] = useState(1);
  const [uploadSucess, setUploadSucess] = useState(false);
  const { t, i18n } = useTranslation();
  // Query Data To Fetch Languages
  const { data, isLoading, isError } = useQuery('languages', getLanguages, {
    staleTime: 360000000,
  });
  useEffect(() => {
    setLanguageId(data?.data.sort((a, b) => (a.orderNum > b.orderNum ? 1 : -1))[0].id);
  }, [data]);

  const [activePage, setActivePage] = useState();
  // create a loop for localisation
  const branchLngs = data?.data?.map((language) => ({
    languageId: language.id,
    name: '',
    address: '',
  }));
  const initialValues = {
    location: '',
    orderNum: orderNum + 1,
    settingId: 0,
    telephones: [],
    faxs: [],
    whatsAppNumber: '',
    email: '',
    branchLngs: branchLngs,
  };

  const onSubmit = async (e) => {
    try {
      await addBranchMutation.mutate(e);
    } catch (error) {
//       console.log('error', error);
    }
  };

  useEffect(() => {}, [activePage]);
  return (
    <>
      {data && data.data && (
        <Formik
          // onSubmit={onSubmit}
          validateOnBlur={false}
          validateOnChange={false}
          initialValues={initialValues}
        >
          {({ values, setFieldValue, errors }) => {
            return (
              <Form>
                <Modal
                  className="sm:max-w-3xl"
                  isOpen={isOpen}
                  setIsOpen={setIsOpen}
                  onSubmit={() => onSubmit(values)}
                  title={` ${t('Add Branch')} `}
                  isLoading={addBranchMutation.isLoading}
                  add={true}
                  submitType="button"
                >
                  {isLoading && <Loading />}
                  {isError && 'error'}
                  {data && (
                    <LanguageList
                      className="flex transform translate-y-1 relative z-10 mb-4"
                      languages={data?.data}
                      languageId={languageId}
                      setLanguageId={setLanguageId}
                    >
                      <hr className="border w-full absolute bottom-0 left-0 z-0" />
                    </LanguageList>
                  )}
                  {/* Submit Form */}
                  <div className={`grid grid-cols-2 ${i18n.language === 'en' ? 'text-left' : 'text-right'}  gap-6`}>
                    <div>
                      {values &&
                        values.branchLngs &&
                        values?.branchLngs.map((asset, index) => (
                          <FieldArray
                            key={index}
                            name="branchLngs"
                            render={(arrayHelpers) => (
                              <>
                                {languageId === asset.languageId && (
                                  <>
                                    <label>
                                      <b className="font-semibold block text-gray-700">{t('Name')}</b>
                                      <Field
                                        className="border rounded  w-full mb-4 p-1"
                                        type="text"
                                        name={`branchLngs[${index}].name`}
                                      />
                                    </label>
                                    <label>
                                      <b className="font-semibold block text-gray-700">{t('Address')}</b>
                                      <Field
                                        className="border rounded  w-full mb-4 p-1"
                                        type="text"
                                        name={`branchLngs[${index}].address`}
                                      />
                                    </label>
                                  </>
                                )}
                              </>
                            )}
                          />
                        ))}
                    </div>
                    <div>
                      <label>
                        <b className="font-semibold block text-gray-700">{t('whatsApp Number')}</b>
                        <Field className="border rounded  w-full mb-4 p-1" type="text" name={`whatsAppNumber`} />
                      </label>
                      <label>
                        <b className="font-semibold block text-gray-700">{t('Email')}</b>
                        <Field className="border rounded  w-full mb-4 p-1" type="text" name={`email`} />
                      </label>
                    </div>
                  </div>
                </Modal>
              </Form>
            );
          }}
        </Formik>
      )}
    </>
  );
};
